export const state = {
    produtosSemCadastroResponse: { content: [] },
    produtoSemCadastroSelected: {},
    fotografiaProdutoDetails: {},
    fotografiaEmpresasResponse: [],
}

export const mutations = {
    SET_PRODUTOS_SEM_CADASTRO_RESPONSE(state, payload) {
        state.produtosSemCadastroResponse = payload
    },
    SET_PRODUTO_SEM_CADASTRO_SELECTED(state, payload) {
        state.produtoSemCadastroSelected = payload
    },
    SET_FOTOGRAFIA_PRODUTO_DETAILS(state, payload) {
        state.fotografiaProdutoDetails = payload
    },
    SET_FOTOGRAFIA_EMPRESAS_RESPONSE(state, payload) {
        state.fotografiaEmpresasResponse = payload
    },
}


export const actions = {
    changeProdutosSemCadastroResponse({ commit }, payload) {
        commit('SET_PRODUTOS_SEM_CADASTRO_RESPONSE', payload)
    },
    changeProdutoSemCadastroSelected({ commit }, payload) {
        commit('SET_PRODUTO_SEM_CADASTRO_SELECTED', payload)
    },
    changeFotografiaProdutoDetails({ commit }, payload) {
        commit('SET_FOTOGRAFIA_PRODUTO_DETAILS', payload)
    },
    changeFotografiaEmpresasResponse({ commit }, payload) {
        commit('SET_FOTOGRAFIA_EMPRESAS_RESPONSE', payload)
    },
}